document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('[data-td-gallery]').forEach(function (gallery) {
    const mainImg = document.getElementById('mainImg-' + gallery.getAttribute('data-td-gallery'));
    if (!mainImg) return;
    const thumbs = gallery.querySelectorAll('[data-td-thumb]');
    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        // Swap srcset as well as src: while a srcset is present the browser ignores a new src.
        mainImg.srcset = thumb.dataset.fullSrcset || '';
        mainImg.src = thumb.dataset.fullSrc;
        mainImg.alt = thumb.dataset.alt || '';
        thumbs.forEach(function (t) {
          t.classList.remove('active');
          t.removeAttribute('aria-current');
        });
        thumb.classList.add('active');
        thumb.setAttribute('aria-current', 'true');
      });
    });
  });

  const sticky = document.querySelector('[data-td-sticky]');
  const mainButton = sticky && document.querySelector('#' + sticky.querySelector('[form]').getAttribute('form') + ' [type="submit"]');
  if (sticky && mainButton && 'IntersectionObserver' in window) {
    const mobile = window.matchMedia('(max-width: 760px)');
    let mainVisible = true;
    const update = function () {
      const show = mobile.matches && !mainVisible;
      sticky.hidden = !show;
      document.body.classList.toggle('td-sticky-on', show);
    };
    // Show the bar only while the main button is off screen, so there is never a second button on top of it.
    new IntersectionObserver(function (entries) {
      mainVisible = entries[0].isIntersecting;
      update();
    }).observe(mainButton);
    mobile.addEventListener('change', update);
  }

  document.querySelectorAll('[data-td-qty-input]').forEach(function (input) {
    const row = input.closest('.qty');
    if (!row) return;
    const dec = row.querySelector('[data-td-qty-decrease]');
    const inc = row.querySelector('[data-td-qty-increase]');
    if (dec) {
      dec.addEventListener('click', function () {
        input.value = Math.max(1, (parseInt(input.value, 10) || 1) - 1);
      });
    }
    if (inc) {
      inc.addEventListener('click', function () {
        input.value = Math.max(1, (parseInt(input.value, 10) || 1) + 1);
      });
    }
  });
});
